import axios from 'axios';
import { useReduxSelector } from 'hooks';
import { useMemo } from 'react';
import { IStoreAuthentication } from 'store/types';
import { decodeAuthToken } from 'utils/authenticationUtils';
import { compactObject } from 'utils/objectUtils';

export default function useGustoAxios() {
  const url = useReduxSelector((state) => state.environment.REACT_APP_GUSTO_URL);
  const token = useReduxSelector((state: { authentication: IStoreAuthentication }) => state.authentication.token);
  const keyAuthorization = decodeAuthToken(token || '').keyAuthorization;

  return useMemo(() => {
    return axios.create({
      baseURL: url,
      headers: compactObject({
        'Content-Type': 'application/json',
        'key-authorization': keyAuthorization,
      }),
    });
  }, [url, keyAuthorization]);
}
